import { Unit } from '@silbo/core';
import { queryOptions } from '@tanstack/react-query';
import { getRequestsQuery } from './get-requests-query';

export const getRequestsQueryOptions = (units: Unit[]) =>
  queryOptions({
    queryKey: [getRequestsQuery(units).className, getRequestsQuery(units).toJSON()],
    queryFn: async () => {
      const query = getRequestsQuery(units);
      return await query.find();
    },
    enabled: units.length > 0,
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  });
